/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import customer from "../../http/requests/customer";

export default {
	exportData({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				customer
					.exportData(payload)
					.then(response => {
						resolve(response && response.data ? response.data : null);
					})
					.catch(error => {
						reject(error);
					});
			});
		} catch (error) {
			console.error("[fetchPond]", error);
		}
	},
	exportCustomerData({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				customer
					.exportCustomerData(payload)
					.then(response => {
						if (response.data && response.data.error_code !== 0) {
							reject({ message: response.data.error_message });
						} else {
							resolve(response.data);
						}
					})
					.catch(error => {
						reject(error);
					});
			});
		} catch (error) {
			console.error("[fetchPond]", error);
		}
	},
	exportRawPondData({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				customer
					.exportRawPondData(payload)
					.then(response => {
						if (response.data && response.data.error_code !== 0) {
							reject({ message: response.data.error_message });
						} else {
							resolve(response.data);
						}
					})
					.catch(error => {
						reject(error);
					});
			});
		} catch (error) {
			console.error("[fetchPond]", error);
		}
	},
	addCustomer({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				customer
					.createCustomer(payload)
					.then(response => {
						if (response.data && response.data.error_code !== 0) {
							console.log("[ADD_CUSTOMER] throw");
							// throw response.data.error_message;
							reject({ message: response.data.error_message });
						} else {
							console.log("[ADD_CUSTOMER]", response.data.data.customer);
							commit("ADD_CUSTOMER", response.data.data.customer);
							resolve(response);
						}
					})
					.catch(error => {
						reject(error);
					});
			});
		} catch (error) {
			console.error("[addCustomer]", error);
		}
	},
	updateCustomer({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				customer
					.updateCustomer(payload.id, payload.data)
					.then(response => {
						if (response.data && response.data.error_code !== 0) {
							console.log("[UPDATE_CUSTOMER] throw");
							throw response.data.error_message;
						} else {
							console.log("[UPDATE_CUSTOMER]", response.data.data.customer);
							commit("UPDATE_CUSTOMER", response.data);
							resolve(response);
						}
					})
					.catch(error => {
						reject(error);
					});
			});
		} catch (error) {
			console.error("[updateCustomer]", error);
		}
	},
	fetchCustomers({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				customer
					.getCustomerList(payload)
					.then(response => {
						commit("SET_CUSTOMERS", response.data.data.customers);
						commit("SET_TOTAL_CUSTOMERS", response.data.data.total);
						resolve(response.data.data.customers);
					})
					.catch(error => {
						console.log("error");
						console.log(error);
						reject(error);
					});
			});
		} catch (error) {
			console.error("[fetchCustomers]", error);
		}
	},
	fetchPureCustomers({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				customer
					.getCustomerV1List(payload)
					.then(response => {
						// commit("SET_CUSTOMERS", response.data.data.customers);
						// commit("SET_TOTAL_CUSTOMERS", response.data.data.total);
						resolve(response.data.data.customers);
					})
					.catch(error => {
						reject(error);
					});
			});
		} catch (error) {
			console.error("[fetchCustomers]", error);
		}
	},
	fetchPureAllCustomers({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				customer
					.getAllCustomes(payload)
					.then(response => {
						// commit("SET_CUSTOMERS", response.data.data.customers);
						// commit("SET_TOTAL_CUSTOMERS", response.data.data.total);
						resolve(response.data.data.customers);
					})
					.catch(error => {
						reject(error);
					});
			});
		} catch (error) {
			console.error("[fetchCustomers]", error);
		}
	},
	fetchCustomer({ commit }, userId) {
		try {
			return new Promise((resolve, reject) => {
				customer
					.getCustomer(userId)
					.then(response => {
						resolve(response && response.data ? response.data : response);
						// if (response.data && response.data.error_code !== 0) {
						// 	console.log("[getCustomer] throw");
						// 	reject(response.data.error_message);
						// 	throw response.data.error_message;
						// } else {
						// 	console.log("[getCustomer]", response.data.customer);
						// 	commit("UPDATE_CUSTOMER", response.data.customer);
						// 	resolve(response.data.customer);
						// }
					})
					.catch(error => {
						reject(error);
					});
			});
		} catch (error) {
			console.error("[fetchCustomer]", error);
		}
	},
	removeRecord({ commit }, userId) {
		try {
			return new Promise((resolve, reject) => {
				customer
					.deleteCustomer(userId)
					.then(response => {
						if (response.data && response.data.error_code !== 0) {
							console.log("[deleteCustomer] throw");
							reject(response.data.error_message);
							throw response.data.error_message;
						} else {
							commit("REMOVE_RECORD", userId);
							resolve(response.data);
						}
					})
					.catch(error => {
						reject(error);
					});
			});
		} catch (error) {
			console.error("[deleteCustomer]", error);
		}
	},
	removeRecordV2({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				customer
					.deleteCustomerV2(payload)
					.then(response => {
						if (response.data && response.data.error_code !== 0) {
							console.log("[deleteCustomer] throw");
							reject(response.data.error_message);
							throw response.data.error_message;
						} else {
							resolve(response);
						}
					})
					.catch(error => {
						reject(error);
					});
			});
		} catch (error) {
			console.error("[deleteCustomer]", error);
		}
	},
	setCustomersFilters({ commit }, filters) {
		commit("SET_FILTERS", filters);
	}
};
